{
  "showMore": { "whenCollapsed": "Afficher plus", "whenExpanded": "Afficher moins" }
}
